var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChangePassword = function SvgChangePassword(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 7.33333H13.8125V5.2381C13.8125 2.34667 11.4325 0 8.5 0C5.5675 0 3.1875 2.34667 3.1875 5.2381V7.33333H2.125C0.95625 7.33333 0 8.27619 0 9.42857V19.9048C0 21.0571 0.95625 22 2.125 22H14.875C16.0438 22 17 21.0571 17 19.9048V9.42857C17 8.27619 16.0438 7.33333 14.875 7.33333ZM5.3125 5.2381C5.3125 3.49905 6.73625 2.09524 8.5 2.09524C10.2638 2.09524 11.6875 3.49905 11.6875 5.2381V7.33333H5.3125V5.2381ZM14.875 19.9048H2.125V9.42857H14.875V19.9048ZM8.5 16.7619C9.66875 16.7619 10.625 15.819 10.625 14.6667C10.625 13.5143 9.66875 12.5714 8.5 12.5714C7.33125 12.5714 6.375 13.5143 6.375 14.6667C6.375 15.819 7.33125 16.7619 8.5 16.7619Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChangePassword);
export default ForwardRef;